/**
 * Configuración y constantes para el módulo de cuentas bancarias
 */

export const ITEMS_PER_PAGE = 10;

export const INITIAL_BANK_ACCOUNT_STATE = {
  uuid: null,
  bank_name: '',
  account_number: '',
  account_type: '',
  cbu: '',
  alias: '',
  is_active: true,
};

export const VALIDATION_RULES = {
  REQUIRED_FIELDS: ['bank_name', 'account_number', 'account_type', 'cbu'],
  CBU_LENGTH: 22,
  ACCOUNT_NUMBER_MAX_LENGTH: 50,
  ALIAS_MAX_LENGTH: 50,
};

export const BANK_NAME_OPTIONS = [
  { value: 'BANCO_GALICIA', label: 'Banco Galicia' },
  { value: 'BANCO_NACION', label: 'Banco Nación' },
  { value: 'BANCO_PROVINCIA_BUENOS_AIRES', label: 'Banco Provincia de Buenos Aires' },
  { value: 'BANCO_ICBC', label: 'ICBC' },
  { value: 'CITIBANK', label: 'Citibank' },
  { value: 'BANCO_BBVA', label: 'BBVA' },
  { value: 'BANCO_PROVINCIA_CORDOBA', label: 'Banco Provincia de Córdoba' },
  { value: 'BANCO_SUPERVIELLE', label: 'Supervielle' },
  { value: 'BANCO_CIUDAD', label: 'Banco Ciudad' },
  { value: 'BANCO_PATAGONIA', label: 'Banco Patagonia' },
  { value: 'BANCO_HIPOTECARIO', label: 'Banco Hipotecario' },
  { value: 'BANCO_SAN_JUAN', label: 'Banco San Juan' },
  { value: 'BANCO_MUNICIPAL_ROSARIO', label: 'Banco Municipal de Rosario' },
  { value: 'BANCO_SANTANDER', label: 'Banco Santander' },
  { value: 'BANCO_CHUBUT', label: 'Banco del Chubut' },
  { value: 'BANCO_MACRO', label: 'Banco Macro' },
  { value: 'BANCO_CREDICOOP', label: 'Banco Credicoop' },
  { value: 'HSBC_ARGENTINA', label: 'HSBC Argentina' },
  { value: 'BANCO_FRANCES', label: 'Banco Francés' },
  { value: 'BANCO_COMAFI', label: 'Banco Comafi' },
  { value: 'BANCO_ITAU', label: 'Banco Itaú' },
  { value: 'BANCO_INDUSTRIAL', label: 'Banco Industrial' },
  { value: 'BANCO_PIANO', label: 'Banco Piano' },
  { value: 'BANCO_VOII', label: 'Banco VOII' },
  { value: 'BRUBANK', label: 'Brubank' },
  { value: 'BANCO_DEL_SOL', label: 'Banco del Sol' },
  { value: 'BANCO_MASVENTAS', label: 'Banco Masventas' },
  { value: 'BANCO_ROELA', label: 'Banco Roela' },
];

export const ACCOUNT_TYPE_OPTIONS = [
  { value: 'CHECKING_ACCOUNT', label: 'Cuenta Corriente' },
  { value: 'SAVINGS_ACCOUNT', label: 'Caja de Ahorro' },
];

export const TABLE_COLUMNS = {
  bankName: { width: '20%' },
  accountNumber: { width: '20%' },
  accountType: { width: '15%' },
  cbu: { width: '25%' },
  alias: { width: '15%' },
  actions: { width: '10%' },
};

export const MESSAGES = {
  SUCCESS: {
    CREATE: 'Cuenta bancaria creada correctamente',
    UPDATE: 'Cuenta bancaria actualizada correctamente',
    DELETE: 'Cuenta bancaria eliminada correctamente',
  },
  ERROR: {
    CREATE: 'Ocurrió un error al crear la cuenta bancaria',
    UPDATE: 'Ocurrió un error al actualizar la cuenta bancaria',
    DELETE: 'Ocurrió un error al eliminar la cuenta bancaria',
    REQUIRED_FIELD: 'Este campo es obligatorio',
    INVALID_CBU: 'El CBU es inválido',
    INVALID_ACCOUNT_NUMBER: 'El número de cuenta no puede estar vacío',
  },
};
